<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="show"
      persistent
      width="70%"
      height="80%"
    >
      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          Help for JLL’s Site Selector Tool
        </v-card-title>
  
        <v-card-text class="grey lighten-3">
          <v-container>
            <v-layout column style="height: 60vh; position: relative">
              <v-flex xs12 style="overflow: auto">

                <div class="helpcontent-container">
                  <v-card class="ml-1 mr-1 mt-2">
                  <div class="helpcontent pa-5">
                    <h1>Site Selector Tool</h1>
                    
                    <img :src="require('../assets/fcc-add-location-screen.png')" class="img-sm" />
                    <h4>+ Locations to Compare</h4>
                    <p>
                      Add locations to compare total operating cost of a facility
                    </p>
                    
                    
                    <h2>Compare Costs in Different Markets Bar</h2>
                    <img :src="require('../assets/fcc-compare-adjusters-screen.png')" />
                    <p>
                      Use the controls in this area to change values across all the markets you have created
                    </p>
                    
                    <h4>Total Square Footage</h4>
                    <p>
                      Use this slide to adjust the Square footage of the new facility
                    </p>
                    
                    <h4>Head Count Per Warehouse</h4>
                    <p>
                      Use this slide to adjust the total # of warehouse employees in the facility 
                    </p>
                    
                    <h4>Containers Per Year</h4>
                    <p>
                      Use this slide to adjust the number of inbound containers the facility will receive annually
                    </p>
                    
                    <h4>Cost Comparison Detail link</h4>
                    <p>
                      Click here to show the detailed costs of each field. Click a $$ to enter custom amounts where client knows the true cost.
                    </p>
                    
                    
                    <h2>Total Cost Comparison Graph</h2>
                    <img :src="require('../assets/fcc-cost-comparison-graph-screen.png')" />
                    <p>
                      Compares each locations costs side by side. Colors indicate individual cost buckets. Scroll over each color to show the total $$ value of each bucket and the % of the total Operating Cost.
                    </p>
                    
                    <h1>General</h1>
                    <ul>
                      <li>
                        The data for the included market options is tracked by JLL research and updated regularly.
                      </li>
                      <li>
                        Real Estate lease rates are reflective of each submarket and the Square Feet of the facility being modeled. 
                      </li>
                      <li>
                        Employee wage rates are average rates for warehouse related employment in each market.
                      </li>
                      <li>
                        Inbound Transportation takes into account current drayage and ancillary costs, multiplied by the # of inbound containers
                      </li>
                      <li>
                        Outbound Transportation is based on proprietary shipping data comparing each major market against one another to determine relative shipping costs
                      </li>
                      <li>
                        To create a custom location, all inputs will start at 0 value and must be inputted by the user.
                      </li>
                    </ul>
                  </div>
                  </v-card>
                </div>

              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>


        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="didSelectOK()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'help-content',
  data () {
    return {
    }
  },

  props: { 
    show: Boolean
  },

  methods: {
    didSelectOK() {
      this.$emit('did-select-ok')      
    }
  },

  components: {
    'intro-bar': () => import ('@/components/IntroBar'),
  }

}

</script>


<style scoped>
.dialog-title {
  font-weight:bold;
  font-size:11pt;
}
.helpcontent-container {
  position: absolute;
  top: -8px;
  width: 100%;
  height: calc(100% - 8px);
  overflow-y:scroll;
}

.helpcontent h1 {
  border-bottom: 1px solid #aaa;
  font-size: 24pt;
  margin: 30px auto 20px auto;
  padding-bottom: 5px;
  text-align: center;
  width: 70%;
}
.helpcontent h1:nth-child(1) {
  margin-top: 0;
}
.helpcontent h2 {
  text-align: center;
  padding-bottom: 10px;
}
.helpcontent p {
  font-size: 11pt;
}
.helpcontent {
  max-width: 760px;
  margin-left: auto;
  margin-right: auto;
}
.helpcontent img {
  box-shadow: 0 0 5px #777777;
  margin: 10px;
  width: calc(100% - 20px);
}
.helpcontent .img-sm {
  margin-left: 25%;
  margin-right: 25%;
  width: 50%;
}
</style>